// Todas las fechas de la app se muestran en hora de Bogotá (America/Bogota,
// UTC-5 fijo, sin horario de verano), sin importar la zona horaria del
// servidor o del navegador de quien la vea. Las fechas se siguen
// guardando en el backend como ISO UTC (new Date().toISOString()); esto
// solo controla cómo se formatean para mostrarlas.
const TZ = "America/Bogota";

export function formatDate(iso, opts = {}) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("es-CO", {
    timeZone: TZ, year: "numeric", month: "short", day: "numeric", ...opts,
  });
}

export function formatDateTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("es-CO", { timeZone: TZ, day: "2-digit", month: "short", year: "numeric" }) +
    " " + d.toLocaleTimeString("es-CO", { timeZone: TZ, hour: "2-digit", minute: "2-digit" });
}

// Fecha de "hoy" (YYYY-MM-DD) en Bogotá. No usar new Date().toISOString().slice(0,10):
// eso da la fecha en UTC, que ya es el día siguiente entre las 7pm y medianoche hora Bogotá.
export function todayBogota() {
  return new Date().toLocaleDateString("en-CA", { timeZone: TZ });
}
